<template>
  <sub-page :title="title">
    <div class="list-page">
      <div class="list-item" v-for="(item, idx) in items" :key="idx" @click="handleItemClick(item)">
        <img :src="item.icon" class="item-icon" :alt="item.title" />
        <span class="item-text">{{ item.title }}</span>
        <svg viewBox="0 0 24 24" class="arrow-icon"><path d="M9 18 L15 12 L9 6" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'Injury',
  components: { SubPage },
  data() {
    return {
      title: '工伤保险',
      items: [
        { title: '工伤待遇支付明细查询', icon: require('@/assets/icons/svc-injury.png') },
        { title: '工伤供养亲属待遇信息', icon: require('@/assets/icons/svc-injury.png') },
        { title: '一次性工伤医疗补助金申领', icon: require('@/assets/icons/svc-injury.png') },
        { title: '伤残待遇申领（一次性伤残补助金、伤残津贴和生活护理费）', icon: require('@/assets/icons/svc-injury.png') },
        { title: '工伤异地居住（就医）申请', icon: require('@/assets/icons/svc-injury.png') }
      ]
    }
  },
  methods: {
    handleItemClick(item) {
      this.$router.push('/social-card-query')
    }
  }
}
</script>

<style scoped>
.list-page {
  background: #F3F8FB;
  min-height: 100%;
}
.list-item {
  display: flex;
  align-items: center;
  height: calc(170 * var(--w));
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 calc(32 * var(--w));
  gap: calc(24 * var(--w));
  cursor: pointer;
}
.list-item:last-child {
  border-bottom: none;
}
.item-icon {
  width: calc(60 * var(--w));
  height: calc(60 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
}
.item-text {
  flex: 1;
  font-size: calc(36 * var(--w));
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.arrow-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Injury.vue